
import { useBaseRootActions } from '../../baseRoot.actions';
import { configTipoRealocacaoAtom } from './configTipoRealocacaoState';

function useConfigTipoRealocacaoActions() {
  const baseActions = useBaseRootActions('ConfigTipoRealocado', configTipoRealocacaoAtom);
 
  return {
    list: baseActions.list,
    get: baseActions.get,
    create: baseActions.create,
    update: baseActions.update,
    delete: baseActions.delete,
  };
}

export { useConfigTipoRealocacaoActions };
